/* @flow */
import { capitalize, sortBy } from 'lodash';

import type { UserProfilePartial } from 'users/components/UsersProfile';

export function subtextForMember(member: UserProfilePartial) {
  const roles = member.roles
    ? sortBy(member.roles)
        .map(role => capitalize(role))
        .join(', ')
    : null;
  const grade = member.grade ? member.grade : null;

  if (roles && grade) {
    return `${roles}, ${grade}`;
  } else if (roles) {
    return roles;
  } else if (grade) {
    return grade;
  }

  return '';
}
